import React from "react";

import {generateTimeEstimateMessage} from "common/utils/generate_time_remaining_message";

import {DocumentIssue} from "common/types/issue";

type Props = {
  llmIssues: DocumentIssue[];
  incompleteLlmIssues: DocumentIssue[];
  isFlipChecklistIcons: boolean;
  llmIssuesProcessingTime: number;
};

function getPreciseIssueProgress(baseAmount, incompleteLlmIssues) {
  const completeTasks = incompleteLlmIssues
    .map(issue => issue.llm_meta?.completed_task_count)
    .reduce((acc, num) => acc + num, 0);
  const totalTasks = incompleteLlmIssues
    .map(issue => issue.llm_meta?.total_task_count)
    .reduce((acc, num) => acc + num, 0);

  const incompleteAmount = completeTasks / totalTasks;

  return baseAmount + incompleteAmount * (1 - baseAmount);
}

export default function IssueProgress({
  llmIssues,
  incompleteLlmIssues,
  isFlipChecklistIcons,
  llmIssuesProcessingTime,
}: Props) {
  const total = llmIssues.length;
  const complete = total - incompleteLlmIssues.length;

  const totalTasks = llmIssues.reduce(
    (sum, issue) => sum + (issue.llm_meta?.total_task_count ?? 0),
    0,
  );

  const baseAmount = complete / total;

  const usingTaskCounts = totalTasks > 0;
  const progressAmount = Math.ceil(
    (usingTaskCounts
      ? getPreciseIssueProgress(baseAmount, incompleteLlmIssues)
      : baseAmount) * 100,
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        color: isFlipChecklistIcons ? "#555" : "#ddd",
      }}
    >
      {`Processing Issues: ${progressAmount}%`}
      <div
        style={{
          fontSize: "12px",
          fontStyle: "italic",
          color: isFlipChecklistIcons ? "#666" : "#ccc",
          fontWeight: 100,
          margin: "2px 0",
        }}
      >
        {generateTimeEstimateMessage(llmIssuesProcessingTime)}
      </div>
      <div
        style={{
          marginTop: 6,
          height: 3,
          width: "100%",
          backgroundColor: "#ccc",
        }}
      >
        <div
          style={{
            height: "100%",
            backgroundColor: "#1f88e5",
            width: `${progressAmount}%`,
          }}
        />
      </div>
    </div>
  );
}
